"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = exports.LinkContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const style_1 = __importDefault(require("style"));
exports.LinkContainer = styled_components_1.default.a `
  cursor: pointer;
  color: ${style_1.default.Color.Blue.S400};
`;
const Link = ({ children, path, }) => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    return ((0, jsx_runtime_1.jsx)(exports.LinkContainer, Object.assign({ onClick: () => {
            navigate(path);
        } }, { children: children })));
};
exports.Link = Link;
